import { getHandler } from 'src/utils/fetchHandler';

export const GET_COUNTRIES = 'GET_COUNTRIES/COUNTRIES/@WISELY/WEB';
export const FETCH_COUNTRIES_FAILED = 'FETCH_COUNTRIES_FAILED/COUNTRIES/@WISELY/WEB';
export const FETCH_COUNTRIES_SUCCEEDED = 'FETCH_COUNTRIES_SUCCEEDED/COUNTRIES/@WISELY/WEB';

export const getCountries = () => ({
	type: GET_COUNTRIES,
});

export const fetchCountriesSucceeded = payload => ({
	type: FETCH_COUNTRIES_SUCCEEDED,
	payload,
});

export const fetchCountriesFailed = payload => ({
	type: FETCH_COUNTRIES_FAILED,
	payload,
});

export const fetchCountries = () => {
	return dispatch => {
		dispatch(getCountries());
		const path = `v2/countries`;

		return getHandler(path)
			.then(json => dispatch(fetchCountriesSucceeded(json)))
			.catch(error => {
				console.error('fetchCountries error', error);
				dispatch(fetchCountriesFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/countries/country.action.js